import styled from 'styled-components';

export const PricingIllustrationContainer = styled('img')`
  width: 208px;
  height: 148px;
  display: flex;
  margin: 0 auto;
`;
